module.exports = __webpack_public_path__ + "img/l.40f417d0.webp";